module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "knowledge-tab"
  }, [_vm._l((_vm.knowledgeRows), function(knowledge) {
    return _c('div', {
      staticClass: "list-knowledge"
    }, [_c('div', {
      on: {
        "click": function($event) {
          _vm.getKnowledge(knowledge)
        }
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "box-new"
    }, [(_vm.knowledgeDateInMonth(knowledge.date)) ? [_c('img', {
      staticClass: "ico-new",
      attrs: {
        "src": require("./img/new-01.png")
      }
    })] : [_c('img', {
      staticClass: "ico-new",
      attrs: {
        "src": require("./img/old-01.png")
      }
    })]], 2), _vm._v(" "), _c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(knowledge.date))]), _vm._v(" "), _c('div', {
      staticClass: "box-ico"
    }, [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (knowledge.file_path),
        expression: "knowledge.file_path"
      }],
      staticClass: "fa fa-paperclip ico-knowledge1 dash-color-skin",
      attrs: {
        "target": "_blank",
        "href": knowledge.file_path,
        "download": "",
        "title": "Download Attach File"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "box-ico"
    }, [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (knowledge.link),
        expression: "knowledge.link"
      }],
      staticClass: "fa fa-link ico-knowledge2 dash-color-skin",
      attrs: {
        "target": "_blank",
        "href": 'http://' + knowledge.link,
        "title": "Open Link"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-12 topic-knowledge"
    }, [_vm._v(_vm._s(knowledge.title))])])])])
  }), _vm._v(" "), (_vm.triggerKnowledgeInfiniteBool) ? _c('hrms-infinite-loading', {
    ref: "knowledgeLoading",
    on: {
      "infinite": _vm.onInfinite
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-56083f9a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/knowledge/index.vue
// module id = 3775
// module chunks = 1